import { render } from "./HollywoodSmilePurpose.vue?vue&type=template&id=339207f8"
import script from "./HollywoodSmilePurpose.vue?vue&type=script&lang=js"
export * from "./HollywoodSmilePurpose.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__